(ns nl.mediquest.lib.router
  (:require
   [bidi.bidi :as bidi]
   [integrant.core :as ig]
   [nl.mediquest.lib.router.navigation-protection :as navigation-protection]
   [nl.mediquest.lib.subs]
   [pushy.core :as pushy]
   [re-frame.core :as re-frame]
   [reagent.core :as r]))

(def ^:private state
  (r/atom {:page-initialized? false}))

(def ^:private history (atom nil))

(def ^{:deprecated "0d46721"} page-initialized?
  "DEPRECATED: used in dashboard, but should be implemented there"
  (r/cursor state [:page-initialized?]))

(defn- set-active-route
  [state active-route]
  (if (= (:active-route state) active-route)
    state
    (assoc state
           :active-route active-route
           :page-initialized? false)))

(defn- standard-404 []
  [:div.flex.justify-center.items-center.h-screen.bg-gray-100
   [:div.text-center
    [:div.text-4xl.text-gray-800.pb-10 "Pagina niet gevonden"]
    [:div.text-6xl.pb-10.font-semibold "404"]
    [:div.text-4xl [:a.underline {:href "/"} "naar beginpagina"]]]])

(defn get-view
  "Gets the current view based on the URL. If no matching route is found,
  return a 404 page. A custom 404 page can be set using by supplying a
  :view-404 key with the reagent component."
  [{:keys [view-404]}]
  (let [{:keys [handler route-params]} (:active-route @state)
        system (re-frame/subscribe [:nl.mediquest.lib.subs/system])
        page (last (ig/find-derived-1 @system handler))]
    (cond
      page [page route-params]
      @system (if view-404 [view-404] [standard-404]))))

;; -- internal-redirect! ----------------------------------------------------
;; To change route after some actions we will need to set url and for that we
;; will use set-token! that needs history and the token
(defn internal-redirect!
  [token]
  (pushy/set-token! @history token))

(defn replace-token!
  "Replace the current history state, avoids creating a new history entry.
  Use when returning to the current url shouldn't be possible."
  [token]
  (pushy/replace-token! @history token))

(defn- on-location-change!
  [[location active-route]]
  (if-let [protected-location @(re-frame/subscribe [::navigation-protection/protected-location])]
    (when-not (= location protected-location)
      (re-frame/dispatch [::navigation-protection/triggered location])
      (internal-redirect! protected-location))
    (do
      (re-frame/dispatch [::on-page-change location active-route])
      (swap! state set-active-route active-route))))

(defn- match-route [router location]
  (when-let [matched-route (bidi/match-route router location)]
    [location matched-route]))

(defn setup-history-listener! [router]
  (reset! history (pushy/pushy
                   on-location-change!
                   (partial match-route router)))
  (pushy/start! @history))

(defmethod ig/init-key :component/routes [_ opts]
  (setup-history-listener! opts))
